import { Component } from 'react';

import { SHr, SPage, SText, STheme } from 'servisofts-component';
import { connect } from 'servisofts-page';
import SSocket from 'servisofts-socket';
import Container from '../../Components/Container';

const today = new Date();
const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
const ultimoDia = lastDayOfMonth.getFullYear() + "-" + (lastDayOfMonth.getMonth() + 1) + "-" + lastDayOfMonth.getDate();


class index extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }
  componentDidMount() {
    this.getData();
  }

  getData() {
    var _from = 123123;

    this.setState({ loading: "cargando", data: null });
    SSocket.sendPromise({
      component: "reporte",
      type: "execute_function",
      func: 'sincronizarMolinete_data',
      params: ["'" + _from + "'"],
      ...this.params
    })
      .then((resp) => {
        this.setState({ loading: false, data: resp.data });
      })
      .catch((e) => {
        this.setState({ loading: false, error: e });
      });
  }

  render() {

    return <>
      <SPage title={this.state.title} center backgroundColor={"transparent"}>

        <Container>
          <SText fontSize={36} font={"Roboto"} bold color={STheme.color.text} center>Calendario</SText>
          <SHr height={40} />

        </Container>
      </SPage>

    </>
  }
}
export default connect(index);